const COLOR_MAP = {
  "#2563eb": "var(--blog-blue)",
  "#059669": "var(--blog-green)",
  "#ea580c": "var(--blog-orange)",
  "#0284c7": "var(--blog-sky)",
  "#7c3aed": "var(--blog-violet)",
  "#db2777": "var(--blog-pink)",
  "#dc2626": "var(--blog-red)",
};

export function blogSpanComponent(props) {
  const { style, children, ...rest } = props;
  if (style?.color) {
    const key = style.color.toLowerCase();
    const cssVar = COLOR_MAP[key];
    if (cssVar) {
      return <span style={{ ...style, color: cssVar }}>{children}</span>;
    }
  }
  return <span style={style} {...rest}>{children}</span>;
}
